import { render, staticRenderFns } from "./NosePanel.vue?vue&type=template&id=4d578e3e&"
import script from "./NosePanel.vue?vue&type=script&lang=js&"
export * from "./NosePanel.vue?vue&type=script&lang=js&"
import style0 from "./NosePanel.vue?vue&type=style&index=0&id=4d578e3e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports